import { useSelector } from 'react-redux';
import facebookIcon from '../static/images/social_icons/facebook.jpg';
import instagramIcon from '../static/images/social_icons/instagram.jpg';
import tiktokIcon from '../static/images/social_icons/tiktok.jpg';
import youtubeIcon from '../static/images/social_icons/youtube.jpg';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Capacitor } from '@capacitor/core';
import Loader from './Loader';
import Error from './Error';
import CookieSettings from './cookies/CookieSettings';

// Su app nativa non esponiamo la gestione cookie: GA4 resta disattivo, niente
// tracking (vedi CookieBanner.jsx, requisito Apple 5.1.2(i)).
const IS_NATIVE = Capacitor.isNativePlatform();

const Footer = ({ installPwa }) => {
    const { isLogged } = useSelector(state => state.user)
    const { t } = useTranslation();
    const [inputData, setInputData] = useState(null);
    const handleInputData = (event) => {
        const { value } = event.target;
        setInputData(value);
    }
    const [fetchStatus, setFetchStatus] = useState('idle');
    const [error, setError] = useState(null);
    const [cookieSettingsOpen, setCookieSettingsOpen] = useState(false);
    const sendEmail = async () => {
        setFetchStatus('loading');
        const url = `${process.env.REACT_APP_SERVER_BASE_URL}/users/get-newsletter`;
        const headers = { 'Content-Type': 'application/json' };
        const options = { method: 'POST', headers, body: JSON.stringify({ email: inputData }) };
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                setFetchStatus('succeeded');
            } else {
                const error = await response.json();
                throw error;
            }
        } catch (error) {
            setFetchStatus('failed');
            setError(error.message || "Error nell'invio dei dati.")
        }
    }

    return (
        <div className="w-full flex flex-col xl:flex-row xl:justify-between gap-8 xl:gap-0 mt-16 border-t-2 py-16 text-sm">

            {/* Colonna TicinoWild — chi siamo / contatti / partner */}
            <div className="flex flex-col gap-4">
                <h3 className="text-[#225424]">TicinoWild</h3>
                <div><Link to="/who-we-are">{t('Footer.who')}</Link></div>
                <div><Link to="/contacts">{t('Footer.contacts')}</Link></div>
                <div><Link to="/partner">{t('Footer.becomePartner')}</Link></div>
            </div>

            {/* Colonna Account — gestione profilo (loggato) o accesso/registrazione */}
            <div>
                {
                    isLogged ? (
                        <div className="flex flex-col gap-4">
                            <h3 className="text-[#225424] hidden md:block">{t('Footer.account')}</h3>
                            <div className="hidden md:block"><Link to="my-profile">{t('Footer.handleProfile')}</Link></div>
                        </div>
                    ) : (
                        <div className="flex flex-col gap-4">
                            <h3 className="text-[#225424]">{t('Footer.account')}</h3>
                            <div><Link to="/register-login?section=Login">{t('Footer.login')}</Link></div>
                            <div><Link to="/register-login?section=Register">{t('Footer.register')}</Link></div>
                        </div>
                    )
                }
            </div >

            {/* Colonna Informazioni — link legali + gestione cookie */}
            <div className="flex flex-col gap-4">
                <h3 className="text-[#225424]">{t('Footer.information')}</h3>
                <div><Link to="/terms-and-conditions">{t('Footer.termsAndConditions')}</Link></div>
                <div><Link to="/privacy-policy">{t('Footer.privacyPolicy')}</Link></div>
                <div><Link to="/impressum">{t('Footer.impressum')}</Link></div>
                <div><Link to="/image-disclaimer">{t('Footer.imageDisclaimer')}</Link></div>
                {!IS_NATIVE && (
                    <div>
                        <button type="button" onClick={() => setCookieSettingsOpen(true)} className="text-left underline-offset-2 hover:underline">
                            {t('Footer.manageCookies')}
                        </button>
                    </div>
                )}
            </div>

            <div className="flex flex-col gap-2">
                <div className='flex gap-2'>
                    <Link to="https://www.facebook.com/profile.php?id=100093522121374" target="_blank"><img src={facebookIcon} alt="facebook" className='w-12' /></Link>
                    <Link to="https://www.instagram.com/ticinowild/?igsh=NzJydm9nY3AycjFk#" target="_blank"><img src={instagramIcon} alt="instagram" className='w-12' /></Link>
                    <Link to="https://www.tiktok.com/@ticinowild?is_from_webapp=1&sender_device=pc" target="_blank"><img src={tiktokIcon} alt="tiktok" className='w-12' /></Link>
                    <Link to="https://www.youtube.com/@TicinoWild" target="_blank"><img src={youtubeIcon} alt="youtube" className='w-12' /></Link>
                </div>
                {/* <h4 className="text-[#225424] cursor-pointer" onClick={() => installPwa('yes')}>{t('Footer.downloadApp')}</h4> */}
            </div>

            <div className="flex flex-col gap-4">
                <div className='flex flex-col md:flex-row gap-2 md:items-end'>
                    <div className='text-2xl font-bold text-[#225424]'>{t('Footer.dontMissNewsFirst')}</div>
                    <div className='text-lg font-bold'>{t('Footer.dontMissNewsSecond')}</div>
                </div>
                {/* <h3 className="text-[#225424]">{t('Footer.dontMissNews')}</h3> */}
                <div className="flex items-center justify-between border rounded-full py-2 px-2.5 gap-4">
                    <input type="email" placeholder="email" className="h-12 bg-transparent border-0 rounded-full w-full md:min-w-96 md:" onChange={handleInputData} />
                    {
                        fetchStatus === 'idle' &&
                        <button className="bg-white py-3 px-4 h-fit rounded-full text-[#225424] min-w-fit" onClick={sendEmail}>{t('Footer.newsletterSignUp')}</button>
                    }
                    {
                        fetchStatus === 'loading' &&
                        <Loader />
                    }
                    {
                        fetchStatus === 'failed' &&
                        <Error text={error} message="Ricarica la pagina e riprova." />
                    }
                    {
                        fetchStatus === 'succeeded' &&
                        <h4>Iscrizione avvenuta con successo</h4>
                    }
                </div>
            </div>

            {!IS_NATIVE && <CookieSettings isOpen={cookieSettingsOpen} onClose={() => setCookieSettingsOpen(false)} />}
        </div >
    )
}

export default Footer;